import { connect } from 'react-redux';
import TimeSheet from './TimeSheet';
import {
    getTimeSheetListBegin,
    getTimeSheetTypesBegin,
    getTimeSheetDetailsBegin,
    setSelectedTimeSheetDate,
    getTimeSheetCategoriesBegin,
    openTimeSheetForSelectedDateBegin,
    getTimeSheetExpenseCategoriesBegin,
    mergeTimesheetDocumentsBegin,
    getTimesheetSearchConfiguredFormBegin,
    applyTimesheetFilters,
    setTimeSheetFilterSelections,
} from './../../store/actions/timeSheet.actions';
import {
    getTimeSheetList,
    getTimeSheetLoading,
    getLoadMore,
    getTimeSheetCount,
    getTimeSheetDetail,
    getFilteredTimeSheetListLoading,
    getTimesheetSearchFormLoadingStatus,
    getTimesheetSearchForm,
    getTimeSheetFilterSelections,
} from '../../store/selectors/timeSheet.selectors';
import { getMergeTemplatesBegin } from '../../store/actions/license.actions';
import { getMergeTemplatesList } from '../../store/selectors/license.selectors';
import { getLoggedInUser } from 'src/store/selectors/authentication.selectors';

const mapStateToProps = (state: any) => {
    const timeSheetList = getTimeSheetList(state);
    const isLoading = getTimeSheetLoading(state);
    const hasMore = getLoadMore(state);
    const timeSheetCount = getTimeSheetCount(state);
    const isFilteredLoading = getFilteredTimeSheetListLoading(state);
    const timeSheet = getTimeSheetDetail(state);
    const mergeTemplateList = getMergeTemplatesList(state);
    const isSearchFormLoading = getTimesheetSearchFormLoadingStatus(state);
    const searchForm = getTimesheetSearchForm(state);
    const loggedInUser = getLoggedInUser(state);
    const filterSelections = getTimeSheetFilterSelections(state);
    return {
        timeSheetList,
        isLoading,
        hasMore,
        timeSheetCount,
        isFilteredLoading,
        timeSheet,
        mergeTemplateList,
        isSearchFormLoading,
        searchForm,
        loggedInUser,
        filterSelections,
    };
};

const mapDispatchToProps = {
    setSelectedTimeSheetDate,
    getTimeSheetList: getTimeSheetListBegin,
    getTimeSheetTypes: getTimeSheetTypesBegin,
    getTimeSheetDetails: getTimeSheetDetailsBegin,
    getTimeSheetCategories: getTimeSheetCategoriesBegin,
    getTimeExpenseCategories: getTimeSheetExpenseCategoriesBegin,
    openTimeSheetForSelectedDate: openTimeSheetForSelectedDateBegin,
    getMergeTemplates: getMergeTemplatesBegin,
    mergeTimesheetDocuments: mergeTimesheetDocumentsBegin,
    getSearchForm: getTimesheetSearchConfiguredFormBegin,
    applyTimesheetFilters,
    setFilterSelections: setTimeSheetFilterSelections,
};

export default connect(mapStateToProps, mapDispatchToProps)(TimeSheet);
